import { Application } from '../models/application.model';
import { Game } from '../models/game.model';
import { IExposableService } from './exposable-service.inteface';

// -----------------------------------------------------------------------------
export const kNameOfTesterWindowService = 'TesterWindowService';

// -----------------------------------------------------------------------------
export interface ITesterWindowService extends IExposableService {
  transferTesterNotification(
    game: Game,
    application: Application,
    environment: string,
  );
  resetNotificationTimestamp();
  resetLocalStorage();
  resetConditionsSummary();
  resetNotificationsHistory();
  getGlobalConfigurations();
  getAllGamesConfigurations();
  getGameConfiguration(gameId: number);
  IsNotificationRunning();
  setEnvironment(environment: string): Promise<boolean>;
}
